import React from "react";
import AllPublisher from "../component/sections/publisher/AllPublisher";
import AddGroupSitePublisherContainer from "../component/sections/publisher/AddGroupSitePublisherContainer";
import AllPagesSitePublisher from "../component/sections/publisher/AllPagesSitePublisher";
import AllPositionsPageSitePublisher from "../component/sections/publisher/AllPositionsPageSitePublisher";
import AllIndependentPositionsSitePublisher from "../component/sections/publisher/AllIndependentPositionsSitePublisher";
import AllPreviewPagesSitePublisher from "../component/sections/publisher/preview/AllPreviewPagesSitePublisher";
import AllPreviewIndependentPositionsSitePublisher from "../component/sections/publisher/preview/AllPreviewIndependentPositionsSitePublisher";
import AllPreviewPositionsPageSitePublisher from "../component/sections/publisher/preview/AllPreviewPositionsPageSitePublisher";
import EditGroupPublisher from "../component/sections/publisher/EditGroupPublisher";
import AddGroupSitePublisherAutomate from "../component/sections/publisher/AddGroupSitePublisherAutomate";

const roleRoutes = [
  {
    path: "/publishers/all",
    render: () => <AllPublisher />,
    exact: true,
  },
  {
    path: "/publishers/add-group/banner",
    render: () => <AddGroupSitePublisherContainer />,
    exact: true,
  },
  {
    /* id => sitePublisherID*/
    path: "/publishers/:id/all-page",
    render: () => <AllPagesSitePublisher />,
    exact: true,
  },
  {
    /* id => sitePublisherID*/
    /* categoryUserSitePublisherID => categoryUserSitePublisherID is optional*/
    path: "/publishers/:id/all-page/:categoryUserSitePublisherID",
    render: () => <AllPagesSitePublisher />,
    exact: true,
  },
  {
    /* id => pageID*/
    path: "/publishers/:id/all-positions/",
    render: () => <AllPositionsPageSitePublisher />,
    exact: true,
  },
  {
    path: "/publishers/:id/all-independent-positions/",
    render: () => <AllIndependentPositionsSitePublisher />,
    exact: true,
  },
  {
    path: "/publishers/preview/:id/all-page",
    render: () => <AllPreviewPagesSitePublisher />,
    exact: true,
  },
  {
    path: "/publishers/preview/:id/all-positions",
    render: () => <AllPreviewPositionsPageSitePublisher />,
    exact: true,
  },
  {
    path: "/publishers/preview/:id/all-independent-positions/",
    render: () => <AllPreviewIndependentPositionsSitePublisher />,
    exact: true,
  },
  {
    path: "/publishers/edit-group/:id",
    render: () => <EditGroupPublisher />,
    exact: true,
  },
  {
    path: "/publishers/add-group-automate/banner",
    render: () => <AddGroupSitePublisherAutomate />,
    exact: true,
  },
];

export default roleRoutes;
